import { Directive, inject } from '@angular/core';
import { Menubar } from '@openng/optimus-ui/menubar';

/**
 * Podmenu `p-menubar` se otevírá najetím myší jako v PrimeNG 17 (původní řešení, nasazený DEV).
 *
 * Menubar z Optimus UI otevírá na desktopu podmenu najetím jen při `dirty === true`. Ten nastaví až stisk
 * myši v menu a zavření menu ho vrátí na `false`, takže bez kliku se podmenu neotevře. Direktiva nastaví
 * `dirty` před každým najetím, zbytek řeší původní obsluha: najetí otevře podmenu položky a zavře ostatní,
 * v mobilním režimu (`breakpoint`) se podmenu najetím neotevírá. Zavírání se nemění (klik mimo menu,
 * opakovaný klik na položku). Knihovna k tomu nemá vstup (`autoDisplay` řídí jen vnořená podmenu).
 * Obchvat stojí na vnitřní logice `Menubar.onItemMouseEnter`: při upgradu Optimus UI ověřit, zda je potřeba.
 *
 * Selektor cílí na element `p-menubar`, takže platí pro každý menubar v komponentě, která direktivu importuje.
 */
@Directive({
  // selektor musí cílit na element knihovny, ne na náš prefix
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'p-menubar',
})
export class MenubarHoverOpenDirective {
  constructor() {
    const menubar = inject(Menubar, { host: true });
    const onItemMouseEnter = menubar.onItemMouseEnter.bind(menubar);
    menubar.onItemMouseEnter = (event) => {
      menubar.dirty = true;
      onItemMouseEnter(event);
    };
  }
}
